export default {
    resalesLanding: {
        sentOn: "Verzonden op",
        toggleContact: "Contactgegevens van het kantoor tonen/verbergen",
        propertyOffers: "Woningaanbod",
        openGallery: "Fotogalerij openen",
        prevPhoto: "Vorige foto",
        nextPhoto: "Volgende foto",
        close: "Sluiten",
        photo: "Foto",
        description: "Omschrijving",
        more: "Meer",
        less: "Minder",
        intFloorSpace: "Woonoppervlak",
        build: "Bebouwd",
        terrace: "Terras",
        garden: "Tuin",
        buildYear: "Bouwjaar",
        fees: "Kosten",
        communityFees: "Servicekosten",
        basuraTax: "Afvalbelasting (Basura)",
        ibiFees: "IBI (onroerendezaakbelasting)",
        securityDeposit: "Borg",
        perMonth: "/maand",
        perWeek: "/week",
        disclaimer: "Disclaimer",
        energyCertificate: "Energiecertificaat",
        pending: "In behandeling",
        rating: "Label",
        presentedBy: "Aangeboden door",
        propertyDetails: "Woningdetails",
        reference: "Referentie",
        referenceShort: "Ref",
        unitUnavailable: "Niet meer beschikbaar",
        availableUnits: "Beschikbare units en prijzen",
        availableUnitsShort: "Beschikbare units",
        unit: "Unit",
        type: "Type",
        floors: "Verdiepingen",
        bedrooms: "Slaapk.",
        bathrooms: "Badk.",
        surfaceArea: "Binnen",
        price: "Prijs",
        status: "Status",
        unitAvailable: "Beschikbaar",
        unitReserved: "Gereserveerd",
        unitSold: "Verkocht",
        seeMore: "Meer tonen",
        seeLess: "Minder tonen",
        floor: "Verdieping",
        storeys: "Bouwlagen",
        keyReady: "Sleutelklaar",
        touristLicence: "Toeristische vergunning",
        firstOccupationLicence: "Vergunning eerste bewoning",
        notKnown: "Niet bekend",
        notProvided: "Niet verstrekt",
        yes: "Ja",
        no: "Nee",
        mortgageAvailable: "Hypotheek mogelijk",
        guaranteedRental: "Gegarandeerde verhuur",
        sellBeforeCompletion: "Contractoverdracht vóór voltooiing",
        sellBeforeCompletionYes: "Toegestaan",
        sellBeforeCompletionNo: "Niet toegestaan",
        sellBeforeCompletionNotProvided: "Niet verstrekt",
        reservation: "Reservering",
        contract: "Contract",
        construction: "Bouw",
        completion: "Oplevering",
        co2: "CO2",
        energyConsumption: "Energieverbruik",
        co2PerYear: "kg CO2/jaar",
        kwhPerYear: "kWh/jaar",
        features: "Kenmerken",
        viewDetails: "Details bekijken",
        hideDetails: "Woningdetails verbergen",
        backToResults: "Resultaten",
        viewProperty: "Bekijk object",
        prevProperty: "Vorige",
        nextProperty: "Volgende",
        viewAllFeatures: "Alle kenmerken bekijken",
        allFeatures: "Alle kenmerken",
        infoOnRequest: "Informatie op aanvraag",
        tbc: "N.t.b.",
        featureCategoryLabels: { pool: "Zwembad", views: "Uitzicht", parking: "Parkeren", kitchen: "Keuken", condition: "Staat", garden: "Tuin" },
        featureQualifierFormat: "{value} {category}",
        location: "Locatie",
        agencyInformation: "Informatie over het kantoor",
        buyingCosts: "Aankoopkosten",
        propertyPrice: "Woningprijs:",
        priceNote: "**De prijs is exclusief belastingen en aankoopkosten.",
        estimatedPurchaseCosts: "Geschatte aankoopkosten:",
        hide: "Verbergen",
        showBreakdown: "Specificatie van de aankoopkosten tonen",
        purchaseCostBreakdown: "Specificatie van de aankoopkosten",
        concept: "Post",
        application: "Toepassing",
        rowTransferTax: "ITP (overdrachtsbelasting, bestaande bouw)",
        rowVat: "Btw (nieuwbouw)",
        rowVatLand: "Btw",
        vatApplication: "10% (4% voor sociale woningbouw)",
        rowStampDuty: "Zegelrecht (AJD)",
        rowNotary: "Notaris",
        rowLandRegistry: "Kadaster",
        officialTariff: "Officieel tarief",
        costRangeNotePrefix: "*De totale kosten voor de koper liggen doorgaans tussen",
        and: "en",
        ofPurchasePrice: "van de aankoopprijs.",
        costApproxNote: "*De geschatte aankoopkosten zijn uitsluitend ter indicatie. De werkelijke kosten kunnen variëren afhankelijk van het pand en de omstandigheden van de koper. Wij raden aan professioneel advies in te winnen voor een exacte berekening.",
        additionalInformation: "Aanvullende informatie",
        addInfoDocument: "*Verkort informatiedocument beschikbaar conform het Andalusische decreet 218/2005",
        addInfoNoFees: "*De koper betaalt geen makelaarskosten",
        formHeading: "Wilt u meer weten over de prijzen en de woning?",
        firstName: "Voornaam",
        enterNumber: "Nummer invoeren",
        email: "E-mail",
        searchCountry: "Zoek land of landcode",
        noMatches: "Geen resultaten",
        consent: "Door op de knop te klikken stemt u in met de verwerking van uw persoonsgegevens conform het privacybeleid, waaronder het verzamelen, bewaren en gebruiken van de verstrekte informatie om contact met u op te nemen en u de benodigde informatie te verstrekken.",
        send: "Versturen",
        contactUs: "Neem contact op",
        yourMessage: "Uw bericht",
        agreeData: "Ik ga ermee akkoord mijn gegevens te verstrekken om een antwoord op mijn informatieverzoek te ontvangen.",
        agreeContact: "Ik verzoek om informatie en ga ermee akkoord te worden benaderd door het bedrijf dat verantwoordelijk is voor de promotie of door de betreffende verkoopagent, via mijn contactgegevens die ik hiervoor vrijwillig verstrek.",
        reject: "Afwijzen",
        like: "Leuk",
        liked: "Bewaard",
        rejected: "Afgewezen",
        offerRejected: "Aanbod afgewezen",
        contact: "Contact",
        call: "Bellen",
        calling: "Bellen naar",
        noPhone: "Geen telefoonnummer beschikbaar",
        enquirySent: "Aanvraag verzonden — we nemen contact op met",
        yourDetails: "uw gegevens",
        respondedTo: "beantwoord",
        noProperties: "Geen woningen om weer te geven.",
        soldOutBody: "De woningen in dit aanbod zijn verkocht of staan niet meer te koop. Neem contact op met het makelaarskantoor voor een bijgewerkte selectie.",
        expiredTitle: "Deze aanbiedingslink is verlopen",
        expiredBody: "Neem contact op met het kantoor voor een actuele link om deze woningen te bekijken.",
        unavailableTitle: "Aanbod niet beschikbaar",
        unavailableBody: "We konden dit aanbod niet laden. Mogelijk is de link ongeldig of is de dienst tijdelijk niet beschikbaar — probeer het later opnieuw of neem contact op met het kantoor.",
    },
    title: "eigenschappen van {agencyName}",
    in: "in",
    propertiesFound: "eigenschappen gevonden",
    toDay: "Vandaag",
    days: "dagen",
    week: "Week",
    year: "Jaar",
    month: "Maand",
    prev: "Vorige",
    next: "Volgende",
    backToList: "Terug naar lijst",
    sorry: "Sorry, wij",
    cantFind: "kan niet vinden",
    lookingFor: "de pagina die u zoekt ...",
    thankYou: "BEDANKT VOOR HET BEZOEKEN VAN ONZE WEBSITE",
    pleaseContact: "Neem contact op met de agent voor een nieuwe URL.",
    ForSale: "SALE",
    ShortTermRental: "Short Rent",
    LongTermRental: "Long Rent",
    showMore: "Meer weergeven",
    showLess: "Show Less",
    price: "Prijs",
    pricePer: "Prijs per",
    built: "Bouwen",
    floorSpace: "Interieur vloeroppervlak",
    terrace: "Terras",
    garden: "Garden",
    plot: "Plot",
    propTitle: '{subType} {searchType} in {location}',
    propTitleShort: '{subType} in {location}',
    notAvailable: "Niet beschikbaar",
    notFound: 'Pagina niet gevonden',
    emptyProperties: "Er zijn geen eigendommen gevonden, neem contact op met uw makelaar voor meer informatie.",
    linkExpired: "Oeps, deze link is verlopen. Neem contact op met uw makelaar om een bijgewerkte woningkoppeling te ontvangen.",
    newDevelopment: "Nieuwe ontwikkeling",
    agencyRaiiNo: "Registratienummer van het agentschap",
    home: {
        verifyYourURLHere: "Verifieer je URL hier. Om dit te doen, log in op WhatsApp in je webbrowser, kopieer dan de URL van WhatsApp naar hier.",
        pasteUrlHere: "Plak URL hier",
        verifyUrl: "Verifieer URL",
        whatIsPropertyViewer: "Wat is Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Deze website wordt gebruikt door makelaars om eigendommen naar hun klanten te sturen. Het is een product van {resalesonlinecom} Neem bij twijfel contact op met de agent die uw eigendommenlijst naar u heeft gestuurd.",
        howDoesItWork: "Hoe werkt het?",
        inThePast: "In het verleden stuurden agents PDF-documenten naar hun klanten. Deze zijn echter niet gemakkelijk te bekijken op veel apparaten. Daarom hebben we {propertyviewercom} gemaakt, zodat de klant gemakkelijker eigenschappen kan bekijken die naar hen worden verzonden.",
        createAShortList: "De agent maakt een korte lijst met eigenschappen. Wanneer ze deze eigenschappen met u delen, ontvangt u een link. Als u op deze link klikt, ziet u de eigenschappen."
    },

    list: {
        propertyTitle: "Klik hier om informatie voor deze accommodatie te bekijken"
    },

    searchType: {
        ForSale: "te koop",
        ShortTermRental: "voor korte termijn verhuur",
        LongTermRental: "voor lange termijn verhuur",
    },

    rsStatus: {
        Available: "Beschikbaar",
        Listing: "Aanbieding",
        UnderOffer: "Onder Aanbieding",
        SaleAgreed: "Verkoop overeengekomen",
        OffMarket: "Off-markt",
        Sold: "Verkocht",
        Rented: "Gehuurd"
    },

    details: {
        average: "Gemiddeld",
        averagePricesFor: "Gemiddelde prijzen voor",
        showFullER: "Show Full",
        thisProperty: "Deze eigenschap",
        infoNotAvailable: "Deze informatie is niet beschikbaar.",
        feesEnergyRating: "Vergoedingen, Energieklasse",
        fees: "vergoedingen",
        ibiFees: "IBI-kosten",
        basuraTax: "Basura-belasting",
        communityFees: "Servicekosten",
        associatedCosts: "Bijkomende kosten",
        energyRating: "	Energielabel",
        securityDeposit: "Waarborgsom",
        energyCertificate: "Energiecertificaat",
        energyCertificatePending: "Het energiecertificaat is in behandeling",
        energyConsumption: "Energieverbruik",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² per jaar",
        kwhPerYear: "kWh/m² per jaar",
        other: "Anderen",
        buildYear: "Bouwjaar",
        forSale: "Te koop",
        sold: "Verkocht",
        longTerm: "Lange termijn",
        shortTermHigh: "Korte termijn hoog",
        shortTermLow: "Korte termijn laag",
        allFeatures: "Alle functies",
        aproxLocation: "Aprox. Locatie",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Toeristisch registratienummer",
        agencyInformation: "Informatie agentschap",
    },
};